<app-navbar-style-two></app-navbar-style-two>

<link href="https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;500;600;700&family=Poppins:wght@600&display=swap" rel="stylesheet">

  <div class="hero-inner">
        <h2 class="hero-title">About Us</h2>
           <!-- <nav class="breadcrumb-container" style="margin:   0px 25px 0px ;">
            <a routerLink="/" class="breadcrumb-link">Home</a>
            <span class="breadcrumb-separator">/</span>
            <span class="breadcrumb-current">About Us</span>
        </nav> -->
    </div> 
 

 
<section class="about-intro">
      
    <div class="container">
        <div class="intro-grid">
            <div class="intro-left reveal from-left">
                <span class="section-eyebrow">Since Day One</span>
                <h2 class="display-heading">The story, passion &amp; magic behind every dish</h2>
                <span class="rule-line"></span>
            </div>
            <div class="intro-right reveal from-right">
                <p class="lead-text">
                    Kitchen Magic was born from family, tradition, and the unforgettable memories created around food.
                    Founded by <strong>Nagarajan Murugan</strong>, who was born and raised in Kanyakumari district, Tamil Nadu,
                    Kitchen Magic is inspired by the warmth of village-style cooking and the love shared through homemade meals.
                </p>
                <p>
                    Growing up in a humble lower middle-class family, Nagarajan&rsquo;s passion for cooking came from watching his father,
                    <strong>Mr.Murugan</strong>, cook special weekend meals while his mother, <strong>Mrs.Kala</strong>, added her own magical
                    finishing touch with freshly ground spices and secret seasonings.
                </p>
            </div>
        </div>
    </div>
</section>

<!-- Story Timeline -->
<section class="about-story">
    <div class="container">
        <div class="story-layout">
            <div class="story-cards">
                <article class="story-card reveal fade-up">
                    <span class="story-icon"><i class="bx bxs-flame"></i></span>
                    <h3>Rooted in Tradition, Inspired by Family</h3>
                    <p>
                        What began around a traditional firewood stove &mdash; surrounded by family, neighbors, laughter, smoky flavors,
                        and joyful memories &mdash; slowly became the foundation of a lifelong dream. As Nagarajan grew into the culinary
                        field, he carried forward the cooking legacy of his father while adding his own modern interpretation of the
                        &ldquo;magic touch&rdquo; inspired by his mother.
                    </p>
                </article>

                <article class="story-card reveal fade-up delay-1">
                    <span class="story-icon gold"><i class="bx bxs-magic-wand"></i></span>
                    <h3>The Legacy Behind the Name</h3>
                    <p>
                        The name <strong>Kitchen Magic</strong> itself represents this beautiful journey &mdash;
                        <strong>&ldquo;K&rdquo;</strong> from <strong>Mrs.Kala</strong> and <strong>&ldquo;M&rdquo;</strong> from
                        <strong>Mr.Murugan</strong> &mdash; honoring the two people who inspired the brand.
                    </p>
                </article>

                <!-- <article class="story-card reveal fade-up delay-2">
                    <span class="story-icon"><i class="bx bx-globe"></i></span>
                    <h3>Global Flavors, Traditional Authenticity</h3>
                    <p>
                        While South Indian cuisine remains at the heart of Kitchen Magic, Nagarajan&rsquo;s experience traveling across
                        India and different parts of the world inspired him to bring together carefully selected flavors and dishes from
                        multiple cuisines &mdash; all blended with the same Kitchen Magic concept.
                    </p>
                </article> -->
            </div>

            <div class="story-figure reveal from-right" #storyFigure>
                <img #storyImg src="assets/img/slider/km_slide1.jpg" alt="Kitchen Magic" onerror="this.src='assets/img/slider/banner2.jpg'">
                <div class="figure-caption">
                    <span>The Kitchen Magic Food Truck &amp; Cloud Kitchen</span>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Founder Spotlight -->
<section class="founder-spotlight">
    <div class="container">
        <div class="founder-grid">
            <div class="founder-figure reveal from-left">
                <img src="assets/img/chef.png" alt="Nagarajan Murugan" onerror="this.src='assets/img/slider/banner2.jpg'">
            </div>
            <div class="founder-content reveal from-right">
                <span class="section-eyebrow">The Founder</span>
                <i class="bx bxs-quote-alt-left quote-mark"></i>
                <blockquote>
                    Kitchen Magic began as a dream to share authentic flavors with the world &mdash; not just through food delivery,
                    but through real human connection. That vision led to the creation of a food truck and cloud kitchen, a place where
                    food, stories, culture, and people come together.
                </blockquote>
                <div class="founder-sign">
                    <h3>Nagarajan Murugan</h3>
                    <p>Founder &amp; Chef &ndash; Kitchen Magic</p>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Vision & Mission -->
<section class="about-values">
    <div class="container">
        <div class="values-layout">
            <!-- Vision -->
            <div class="value-card reveal from-left">
                <div class="value-head">
                    <span class="value-icon"><i class="bx bx-bulb"></i></span>
                    <div>
                        <span class="section-eyebrow">Our Vision</span>
                        <h3>A globally recognized food brand</h3>
                    </div>
                </div>
                <p class="value-desc">
                    To build Kitchen Magic into a globally recognized food brand with food trucks, cloud kitchens, and restaurants that
                    serve authentic flavors using quality, sustainable, and nature-friendly practices.
                </p>
                <div class="pillars-list">
                    <div class="pillar-item">
                        <span class="pillar-icon"><i class="bx bx-world"></i></span>
                        <p>A global presence through food trucks, cloud kitchens, and restaurants.</p>
                    </div>
                    <div class="pillar-item">
                        <span class="pillar-icon"><i class="bx bx-git-branch"></i></span>
                        <p>Bridging heritage recipes with modern, conscientious dining.</p>
                    </div>
                    <div class="pillar-item">
                        <span class="pillar-icon"><i class="bx bx-leaf"></i></span>
                        <p>Nature-friendly practices using sustainable, locally sourced ingredients.</p>
                    </div>
                </div>
            </div>

            <!-- Mission -->
            <div class="value-card reveal from-right">
                <div class="value-head">
                    <span class="value-icon gold"><i class="bx bx-bowl-hot"></i></span>
                    <div>
                        <span class="section-eyebrow">Our Mission</span>
                        <h3>The four pillars of Kitchen Magic</h3>
                    </div>
                </div>
                <ul class="mission-custom-list">
                    <li>
                        <span class="li-icon"><i class="bx bx-heart"></i></span>
                        <p>To create memorable food experiences inspired by tradition and family.</p>
                    </li>
                    <li>
                        <span class="li-icon"><i class="bx bx-bowl-hot"></i></span>
                        <p>To combine authentic South Indian roots with modern culinary creativity.</p>
                    </li>
                    <li>
                        <span class="li-icon"><i class="bx bx-group"></i></span>
                        <p>To bring people together through fresh food, hospitality, and live cooking experiences.</p>
                    </li>
                    <li>
                        <span class="li-icon"><i class="bx bx-star"></i></span>
                        <p>To serve every dish with the same warmth, passion, and &ldquo;magic&rdquo; that inspired the brand.</p>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</section>

 
